import React, { useEffect, useState } from 'react';
import { Phone, Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Inicio',
    href: '#inicio'
  }, {
    name: 'Menú',
    href: '#menu'
  }, {
    name: 'Sobre Nosotros',
    href: '#sobre'
  }, {
    name: 'Ubicación',
    href: '#ubicacion'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-burgundy shadow-lg py-3' : 'bg-transparent py-5'}`} data-id="element-176">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-177">
        {/* Logo */}
        <a href="#inicio" className="flex items-center gap-3 z-50 relative" data-id="element-178">
          <img src="https://cdn.magicpatterns.com/uploads/e7AKa5cjKZiQRF2tewCqsN/ChatGPT_Image_22_may_2026,_08_47_06_p.m..png" alt="The Happy Taco Logo" className="w-12 h-12 object-contain bg-cream rounded-full p-1 shadow-md" width={48} height={48} decoding="async" data-id="element-179" />
          <span className="font-display font-bold text-xl text-cream hidden sm:block tracking-wide" data-id="element-180">
            THE HAPPY TACO
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-181">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-cream/90 hover:text-orange-light font-medium text-sm tracking-widest uppercase transition-colors" data-id="element-182">
              {link.name}
            </a>)}
        </nav>

        {/* Desktop CTA */}
        <div className="hidden md:block" data-id="element-183">
          <a href="tel:+12522131970" className="flex items-center gap-2 bg-orange hover:bg-orange-light text-white px-6 py-2.5 rounded-full font-medium transition-all shadow-md hover:shadow-lg transform hover:-translate-y-0.5" data-id="element-184">
            <Phone size={18} data-id="element-185" />
            <span data-id="element-186">LLAMAR AHORA</span>
          </a>
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden text-cream z-50 relative p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-187">
          {isMobileMenuOpen ? <X size={28} data-id="element-188" /> : <Menu size={28} data-id="element-189" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-190">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 bg-burgundy-dark z-40 flex flex-col items-center justify-center pt-20 px-6" data-id="element-191">
            <nav className="flex flex-col items-center gap-8 w-full" data-id="element-192">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-cream text-2xl font-display tracking-widest uppercase hover:text-orange-light transition-colors" data-id="element-193">
                  {link.name}
                </a>)}
              <a href="tel:+12522131970" onClick={() => setIsMobileMenuOpen(false)} className="flex items-center justify-center gap-3 bg-orange text-white w-full max-w-xs py-4 rounded-full font-bold text-lg mt-8 shadow-lg" data-id="element-194">
                <Phone size={24} data-id="element-195" />
                <span data-id="element-196">(252) 213-1970</span>
              </a>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}